import { render, staticRenderFns } from "./nowPlaying.vue?vue&type=template&id=681ca9d2&"
import script from "./nowPlaying.vue?vue&type=script&lang=js&"
export * from "./nowPlaying.vue?vue&type=script&lang=js&"
import style0 from "./nowPlaying.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports